import { render, staticRenderFns } from "./company-business.vue?vue&type=template&id=a59de23c&"
import script from "./company-business.vue?vue&type=script&lang=js&"
export * from "./company-business.vue?vue&type=script&lang=js&"
import style0 from "./company-business.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports